// import { useEffect } from "react";
// import confetti from "canvas-confetti";
import { Sparkles } from "lucide-react";
import { Button } from "@core/button";
import { useTranslation } from "react-i18next";
interface SuccessNotificationProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  onClose: () => void;
}

export function SuccessNotification({
  title,
  description,
  actionLabel,
  onAction,
  onClose,
}: SuccessNotificationProps) {
  const { t } = useTranslation();
  // useEffect(() => {
  //   const end = Date.now() + 500;

  //   const colors = ["#22c55e", "#16a34a", "#15803d"];

  //   (function frame() {
  //     confetti({
  //       particleCount: 1,
  //       angle: 60,
  //       spread: 10,
  //       origin: { x: 0, y: 0.8 },
  //       colors: colors,
  //     });
  //     confetti({
  //       particleCount: 1,
  //       angle: 120,
  //       spread: 10,
  //       origin: { x: 1, y: 0.8 },
  //       colors: colors,
  //     });

  //     if (Date.now() < end) {
  //       requestAnimationFrame(frame);
  //     }
  //   })();
  // }, []);

  return (
    <div className="fixed bottom-4 right-4 w-11/12 sm:w-4/5 md:w-auto max-w-96 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 animate-slide-up">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <Sparkles className="w-6 h-6 text-green-500" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            {title}
          </h3>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{description}</p>
          <div className="flex justify-end gap-4">
            <Button
              onClick={onClose}
              variant="ghost"
              size="sm"
              rounded="md"
              textColor="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-700"
            >
              {t("common.close")}
            </Button>
            <Button
              onClick={onAction}
              variant="solid"
              size="sm"
              rounded="md"
              className="bg-green-500 hover:bg-green-600 text-white"
            >
              {actionLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
